module.exports = __webpack_public_path__ + "img/PL08335.5ad4c2a6.png";